import { render } from "./NewColisPage.vue?vue&type=template&id=29aa758b&ts=true"
import script from "./NewColisPage.vue?vue&type=script&lang=ts"
export * from "./NewColisPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__